<h1 mat-dialog-title>{{ data.title }}</h1>

<mat-dialog-content>
  <p>{{ data.message }}</p>

  <div class="border border-gray-300 overflow-y-scroll rounded-sm bg-gray-100 max-h-65 mt-2">
    <ul class="list-inside py-2">
      @for (ref of data.references; track $index) {
        <li>
          <div class="flex items-center px-4 py-2">
            <div class="flex-auto pr-4">
              <strong>{{ ref.label }}</strong>
              <span class="block text-gray-500">{{ ref.hint }}</span>
            </div>

            @if (ref.draftId) {
              <button
                class="size-8! p-1.5!"
                mat-icon-button
                matTooltip="Ga naar interactie"
                (click)="navigateTo(ref.draftId)"
              >
                <mat-icon class="size-5! text-xl! leading-none! font-medium!">open_in_new</mat-icon>
              </button>
            }

          </div>
        </li>
      }
    </ul>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (footerTemplate()) {
    <ng-container *ngTemplateOutlet="footerTemplate()!" />
  } @else {
    <button mat-button (click)="handleConfirm()" cdkFocusInitial>Sluiten</button>
  }
</mat-dialog-actions>
